/* eslint-disable @next/next/no-img-element */
import React, { useState, useRef, useEffect } from "react";
import { Button } from "../../../shadcn/components/ui/button";
import ImageUploadSVG from "../../../icons/PostYourProperty/ImageUploadSVG";
import { createFile, deleteFileByUuid, getWatermarkedImgixUrl } from "services";
import { LoadingSpinner } from "../../../icons/LoadingSpinner";
import DocumentTypeSVG from "../../../icons/PostYourProperty/DocumentTypeSVG";
interface FileObject {
  id?: string;
  filename?: string;
}

interface props {
  maxAllowed?: number;
  handleChange: any;
  path?: any;
  owner_service_type: string;
  property_uuid: string;
  allowedMimeTypes?: any;
  showDefaultSVG?: boolean;
  defaultText?: string;
  data: FileObject[];
}

const PYPFileUploader = ({
  data,
  maxAllowed = 10,
  handleChange,
  owner_service_type,
  property_uuid,
  path,
  showDefaultSVG = true,
  defaultText = "",
  allowedMimeTypes = [""],
}: props) => {
  const [selectedfile, setSelectedFile] = useState<FileObject[]>(
    data === undefined ? [] : data,
  );

  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef<any>(null);
  const acceptValue = allowedMimeTypes.join(",");

  const InputChange = async (e: any) => {
    if (selectedfile?.length + e?.target?.files?.length > maxAllowed)
      alert("Max limit exceeded");
    else {
      try {
        for (let i = 0; i < e.target.files.length; i++) {
          let reader = new FileReader();
          let file = e.target.files[i];

          if (file) {
            setLoading(true);
            const response: any = await createFile(file, {
              owner_identifier: property_uuid,
              owner_service: owner_service_type,
            });

            if (response) {
              setLoading(false);
              setSelectedFile((preValue: any) => {
                return [
                  ...preValue,
                  {
                    id: response?.uuid,
                    filename: e.target.files[i].name,
                  },
                ];
              });
            }
          }
        }
      } catch (error) {
        setLoading(false);
        console.log("error", error);
      }
    }
  };
  useEffect(() => {
    if (handleChange) {
      handleChange(path, selectedfile);
    }
  }, [selectedfile]);

  const DeleteSelectFile = async (id: any) => {
    if (window.confirm("Are you sure you want to remove this Image?")) {
      {
        try {
          setLoading(true);
          const response = await deleteFileByUuid(id);
          if (response) {
            setLoading(false);
            const result = selectedfile.filter((data: any) => data.id !== id);
            setSelectedFile(result);
          }
        } catch (error) {
          setLoading(false);
          console.log("error", error);
        }
      }
    } else {
      // alert('No');
    }
  };

  const handleButtonClick = () => {
    // Trigger the click event on the hidden file input
    fileInputRef?.current?.click();
  };

  return (
    <div className="w-full ">
      {/* {loading ? (
        <p>Wait</p>
      ) : 
      ( */}
      <div className=" bg-brand-bgLightGrey w-full ">
        <div className="border border-dashed h-full   py-7 px-8 flex  items-center  justify-center">
          {loading ? (
            <LoadingSpinner className="h-[160px]" />
          ) : (
            <>
              {selectedfile?.length > 0 ? (
                <div className="grid grid-cols-1 mobile:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 mid:grid-cols-4 gap-x-5 gap-y-8">
                  <div
                    className={` hover:cursor-pointer border border-dashed bg-white flex flex-col items-center justify-center max-w-[181px] h-[160px]`}
                    onClick={handleButtonClick}
                  >
                    <input
                      ref={fileInputRef}
                      className="hidden"
                      type="file"
                      id="fileupload"
                      accept={acceptValue}
                      onChange={InputChange}
                      multiple
                    />
                    {showDefaultSVG && (
                      <ImageUploadSVG className="w-[90px] h-[84px] lg:w-[110px] lg:h-[110px]" />
                    )}

                    <p
                      className={`font-openSans ${
                        showDefaultSVG ? "-translate-y-2" : ""
                      }  font-semibold text-mobile-body-sm lg:text-web-body-md leading-4 text-brand-bgBlack`}
                    >
                      + Upload Photo
                    </p>
                  </div>

                  {selectedfile.map((image, index) => (
                    <div
                      className="max-w-[181px] relative max-h-[160px] bg-brand-bgBlack"
                      key={index}
                    >
                      {image?.filename?.match(/.(jpg|jpeg|png|gif|svg)$/i) ? (
                        <img
                          src={getWatermarkedImgixUrl(
                            `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${image?.id}`,
                          )}
                          className="h-full w-full opacity-50"
                          alt=""
                        />
                      ) : (
                        <div className="w-[181px] h-[160px] bg-brand-bgLightGrey border">
                          <DocumentTypeSVG className="w-[170px] h-[110px] opacity-70" />
                          <div className="font-openSans text-center  break-words max-w-[180px] px-2 absolute font-semibold text-web-body-md leading-4 text-brand-bgBlack ">
                            {image?.filename}
                          </div>
                        </div>
                      )}
                      <p
                        onClick={() => DeleteSelectFile(image?.id)}
                        className="absolute hover:cursor-pointer top-1/2 left-1/3  underline text-white font-openSans font-semibold text-web-body-md leading-4"
                      >
                        Remove
                      </p>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="flex flex-col items-center">
                  {showDefaultSVG && <ImageUploadSVG />}
                  <p className="font-openSans text-center font-normal text-web-body-md leading-4 text-brand-textLightGrey">
                    {/* Upload 50 photos of max size 10 mb in format jpg, jpeg & png */}
                    {defaultText}
                  </p>
                  <Button
                    variant={"ghost"}
                    className={` border w-[128px] lg:w-auto border-brand-bgBlack mt-4 font-openSans font-semibold text-mobile-body-sm lg:text-web-body-md leading-4 px-6 lg:px-[26px] text-brand-bgBlack hover:bg-brand-borderGrey`}
                    onClick={handleButtonClick}
                  >
                    <input
                      ref={fileInputRef}
                      className="hidden"
                      type="file"
                      id="fileupload"
                      accept={acceptValue}
                      onChange={InputChange}
                      multiple
                    />
                    Upload Photo
                  </Button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {/* )
      } */}
    </div>
  );
};

export default PYPFileUploader;
